export default __webpack_public_path__ + "80e5f4a78e1b2dd72cb6fe320caaf62c.jpg";